import { primaryKey, editableOnNew, headerCode, inputType, required, length, order, pattern, editable, Describer, visible, GceEntity, textAlign, relation } from './gce-management';
import { PermissionService } from '../../services/permission.service';
import { GceMedicType } from './gce-medic-type';

/**
 * GceInvoicePerson -> table: medici_fatturazione
 */
export class GceInvoicePerson extends GceEntity {
    @primaryKey()
    @headerCode('GCE.GCEINVOICEPERSON.IDFATTURAZIONE')
    @inputType('number')
    @visible(true)
    @editableOnNew(false)
    @order(1)
    idfatturazione: number;

    @headerCode('GCE.GCEINVOICEPERSON.DESCRIZIONE')
    @inputType('text')
    @required()
    @editable(true)
    @length(255)
    @order(2)
    descrizione: string;

    @headerCode('GCE.GCEINVOICEPERSON.EMAIL')
    @inputType('text')
    @required()
    @editable(true)
    @length(255)
    @order(7)
    email: string;

    @headerCode('GCE.GCEINVOICEPERSON.DATA_NASCITA')
    @inputType('date')
    @editable(true)
    @order(8)
    data_nascita: Date | string;

    @headerCode('GCE.GCEINVOICEPERSON.CODICE_FISCALE')
    @inputType('text')
    @editable(true)
    @length(16)
    @order(9)
    codice_fiscale: string;

    @headerCode('GCE.GCEINVOICEPERSON.PIVA')
    @inputType('text')
    @required()
    @editable(true)
    @length(11)
    @order(10)
    piva: string;

    @headerCode('GCE.GCEINVOICEPERSON.FORNITORE_NAV')
    @inputType('text')
    @required()
    @editable(true)
    @length(50)
    @order(11)
    fornitore_nav: string;
/*
    @headerCode('GCE.GCEINVOICEPERSON.CODICE_XDENT')
    @inputType('number')
    @editable(true)
    @length(7)
    @pattern('0000000')
    @textAlign('left')
    @order(12)
    codice_xdent?: number;
*/
    @headerCode('GCE.GCEINVOICEPERSON.MEDICO_PORTALE')
    @inputType('text')
    @editable(false)
    @editableOnNew(false)
    @length(255)
    @order(13)
    medico_portale: string;

    @headerCode('GCE.GCEINVOICEPERSON.PIVA_PORTALE')
    @inputType('text')
    @editable(false)
    @editableOnNew(false)
    @length(255)
    @order(14)
    piva_portale: string;

    @headerCode('GCE.GCEINVOICEPERSON.CFISC_PORTALE')
    @inputType('text')
    @editable(false)
    @editableOnNew(false)
    @length(255)
    @order(15)
    cfisc_portale: string;

    @headerCode('GCE.GCEINVOICEPERSON.REGIME_PORTALE')
    @inputType('text')
    @editable(false)
    @editableOnNew(false)
    @length(50)
    @order(16)
    regime_portale: string;

    @headerCode('GCE.GCEINVOICEPERSON.CAPITALE_PORTALE')
    @inputType('text')
    @editable(false)
    @editableOnNew(false)
    @length(50)
    @order(17)
    capitale_portale: string;

    @headerCode('GCE.GCEINVOICEPERSON.NOME_NAV')
    @inputType('text')
    @editable(false)
    @editableOnNew(false)
    @length(50)
    @order(18)
    nome_nav: string;

    @headerCode('GCE.GCEINVOICEPERSON.PIVA_NAV')
    @inputType('text')
    @editable(false)
    @editableOnNew(false)
    @length(50)
    @order(19)
    piva_nav: string;

    @headerCode('GCE.GCEINVOICEPERSON.CFISC_NAV')
    @inputType('text')
    @editable(false)
    @editableOnNew(false)
    @length(50)
    @order(20)
    cfisc_nav: string;

    @headerCode('GCE.GCEINVOICEPERSON.ANNULLATO')
    @inputType('boolean')
    @editable(false)
    @order(21)
    annullato: boolean;

    @headerCode('GCE.GCEINVOICEPERSON.ERRORE')
    @inputType('boolean')
    @editable(false)
    @order(23)
    errore: boolean;

    @headerCode('GCE.GCEINVOICEPERSON.DESC_ERRORE')
    @inputType('text')
    @editable(false)
    @length(255)
    @order(24)
    desc_errore: string;

    @headerCode('GCE.GCEINVOICEPERSON.TIPO_MEDICO')
    @inputType('select')
    @required()
    @relation("GceMedicType", {columnRel:'tipo_medico', columnDescr:['descrizione']})
    @order(25)
    tipo_medico: number;

    @headerCode('GCE.GCEINVOICEPERSON.INDIRIZZO')
    @inputType('text')
    @required()
    @length(255)
    @order(26)
    indirizzo: string;

    @headerCode('GCE.GCEINVOICEPERSON.CITTA')
    @inputType('text')
    @required()
    @length(255)
    @order(27)
    citta: string;

    @headerCode('GCE.GCEINVOICEPERSON.CAP')
    @inputType('text')
    @required()
    @length(5)
    @order(28)
    cap: string;

    @headerCode('GCE.GCEINVOICEPERSON.PROVINCIA')
    @inputType('select')
    @required()
    @relation("GceProvCodes", {columnRel:'cod_prov', columnDescr:['descrizione']})
    @order(29)
    provincia: string;

    @headerCode('GCE.GCEINVOICEPERSON.CAPITALE_SOCIALE_INVIO_PORTALE')
    @inputType('number')
    @pattern('0000000000.00')
    @order(30)
    capitale_sociale_invio_portale: number;

    @headerCode('GCE.GCEINVOICEPERSON.REGIME_FISCALE_INVIO_PORTALE')
    @inputType('select')
    @required()
    @relation("GceFiscalReg", {columnRel:'tipo_regime', columnDescr:['descrizione']})
    @order(31)
    regime_fiscale_invio_portale: string;

    @headerCode('GCE.GCEINVOICEPERSON.DATAORA_INVIO_INVIO_PORTALE')
    @inputType('datetime')
    @editable(false)
    @order(32)
    dataora_invio_portale: Date | string;

    @headerCode('GCE.GCEINVOICEPERSON.ESITO_INVIO_PORTALE')
    @inputType('text')
    @editable(false)
    @length(10)
    @order(33)
    esito_invio_portale: string;

    @headerCode('GCE.GCEINVOICEPERSON.MESSAGGI_INVIO_PORTALE')
    @inputType('text')
    @editable(false)
    @length(255)
    @order(34)
    messaggio_invio_portale: string;

    @headerCode('GCE.GCEINVOICEPERSON.FLG_INVIO_DATI_PORTALE')
    @inputType('boolean')
    @editable(true)
    @order(35)
    flg_invio_dati_portale: boolean;

    //new fields AR

    @headerCode('GCE.GCEINVOICEPERSON.id_profilo_xdent')
    @inputType('select')
    @editable(true)
    @relation("GceProfiles", {columnRel:'rowid', columnDescr:['descrizione']})
    @order(36)
    id_profilo_xdent : number;

    @headerCode('GCE.GCEINVOICEPERSON.iscrizione_albo_medici')
    @inputType('text')
    @editable(true)
    @length(4)
    @order(37)
    iscrizione_albo_medici :string;

    @headerCode('GCE.GCEINVOICEPERSON.iscrizione_albo_medici_prov')
    @inputType('select')
    @relation("GceProvCodes", {columnRel:'cod_prov', columnDescr:['descrizione']})
    @editable(true)
    @order(38)
    iscrizione_albo_medici_prov:string;

    @headerCode('GCE.GCEINVOICEPERSON.iscrizione_albo_odontoiatri')
    @inputType('text')
    @editable(true)
    @length(4)
    @order(39)
    iscrizione_albo_odontoiatri :string;

    @headerCode('GCE.GCEINVOICEPERSON.iscrizione_albo_odonto_prov')
    @inputType('select')
    @relation("GceProvCodes", {columnRel:'cod_prov', columnDescr:['descrizione']})
    @editable(true)
    @order(40)
    iscrizione_albo_odontoiatri_prov :string;

    @headerCode('GCE.GCEINVOICEPERSON.anno_laurea')
    @inputType('date')
    @editable(true)
    @order(41)
    data_laurea : Date | string;

    @headerCode('GCE.GCEINVOICEPERSON.scadenza_blsd')
    @inputType('date')
    @editable(true)
    @order(42)
    scadenza_blsd: Date | string;

    @headerCode('GCE.GCEINVOICEPERSON.scadenza_radioprotezione')
    @inputType('date')
    @editable(true)
    @order(43)
    scadenza_radioprotezione : Date | string;
    
    @headerCode('GCE.GCEINVOICEPERSON.scadenza_rc_professionale')
    @inputType('date')
    @editable(true)
    @order(44)
    scadenza_rc_professionale : Date | string;

    @headerCode('GCE.GCEINVOICEPERSON.massimale_rc_professionale')
    @inputType('number')
    @editable(true)
    @length(7)
    @pattern('0000000')
    @textAlign('left')
    @order(45)
    massimale_rc_professionale : number;

    @headerCode('GCE.GCEINVOICEPERSON.codice_iban')
    @inputType('text')
    @editable(true)
    @length(27)
    @order(46)
    codice_iban :string;

    @headerCode('GCE.GCEINVOICEPERSON.indirizzo_pec')
    @inputType('text')
    @editable(true)
    @length(100)
    @order(47)
    indirizzo_pec :string;

    @headerCode('GCE.GCEINVOICEPERSON.data_inizio_collaborazione')
    @inputType('date')
    @editable(true)
    @order(48)
    data_inizio_collaborazione: Date | string;

    @headerCode('GCE.GCEINVOICEPERSON.profilo_compenso')
    @inputType('select')
    @editable(true)
    @relation("GceProfiliCompenso", {columnRel:'id', columnDescr:['descrizione']})
    @order(49)
    profilo_compenso: number;

    @headerCode('GCE.GCEINVOICEPERSON.profilo_compenso_desc')
    @inputType('text')
    @editable(false)
    @visible(false)
    @order(50)
    profilo_compenso_desc: string;

    @headerCode('GCE.GCEINVOICEPERSON.CESSATO')
    @inputType('boolean')
    @editable(true)
    @order(22)
    cessato: boolean;

    @headerCode('GCE.GCEINVOICEPERSON.TELEFONO')
    @inputType('text')
    @length(30)
    @order(21)
    telefono?: string;

    @headerCode('GCE.GCEINVOICEPERSON.NOFATTURAE')
    @inputType('boolean')
    @editable(true)
    @order(21)
    flg_nofattura_portale : boolean;

    @headerCode('GCE.GCEINVOICEPERSON.IMG')
    @inputType('file')
    @editable(true)
    @order(3)
    url_image : string;

    // campi aggiunti per l'accordion anagrafica medico (struttura_anagrafica_medico.xlsx)

    @headerCode('GCE.GCEINVOICEPERSON.sesso')
    @inputType('text')
    @editable(true)
    @length(1)
    @order(51)
    sesso: string;

    @headerCode('GCE.GCEINVOICEPERSON.luogo_nascita')
    @inputType('text')
    @editable(true)
    @length(255)
    @order(52)
    luogo_nascita: string;

    @headerCode('GCE.GCEINVOICEPERSON.ranking_operatore')
    @inputType('text')
    @editable(true)
    @length(10)
    @order(53)
    ranking_operatore: string;

    @headerCode('GCE.GCEINVOICEPERSON.profilo_clinico')
    @inputType('text')
    @editable(true)
    @length(100)
    @order(54)
    profilo_clinico: string;

    @headerCode('GCE.GCEINVOICEPERSON.aree_competenza_operatore')
    @inputType('text')
    @editable(true)
    @length(255)
    @order(55)
    aree_competenza_operatore: string;

    @headerCode('GCE.GCEINVOICEPERSON.laurea_luogo')
    @inputType('text')
    @editable(true)
    @length(255)
    @order(56)
    laurea_luogo: string;

    @headerCode('GCE.GCEINVOICEPERSON.laurea_tipologia')
    @inputType('text')
    @editable(true)
    @length(100)
    @order(57)
    laurea_tipologia: string;

    @headerCode('GCE.GCEINVOICEPERSON.laurea_specializzazione')
    @inputType('text')
    @editable(true)
    @length(255)
    @order(58)
    laurea_specializzazione: string;

    @headerCode('GCE.GCEINVOICEPERSON.numero_iscrizione_albo_igienisti')
    @inputType('text')
    @editable(true)
    @length(10)
    @order(59)
    numero_iscrizione_albo_igienisti: string;

    @headerCode('GCE.GCEINVOICEPERSON.data_iscrizione_albo')
    @inputType('date')
    @editable(true)
    @order(60)
    data_iscrizione_albo: Date | string;

    @headerCode('GCE.GCEINVOICEPERSON.data_scadenza_assicurazione')
    @inputType('date')
    @editable(true)
    @order(61)
    data_scadenza_assicurazione: Date | string;

    @headerCode('GCE.GCEINVOICEPERSON.nome_compagnia_assicurazione')
    @inputType('text')
    @editable(true)
    @length(255)
    @order(62)
    nome_compagnia_assicurazione: string;

    @headerCode('GCE.GCEINVOICEPERSON.massimale_assicurazione')
    @inputType('number')
    @editable(true)
    @order(63)
    massimale_assicurazione: number;

    @headerCode('GCE.GCEINVOICEPERSON.data_fine_collaborazione_gruppo')
    @inputType('date')
    @editable(true)
    @order(64)
    data_fine_collaborazione_gruppo: Date | string;

    @headerCode('GCE.GCEINVOICEPERSON.modalita_collaborazione')
    @inputType('text')
    @editable(true)
    @length(50)
    @order(65)
    modalita_collaborazione: string;

    @headerCode('GCE.GCEINVOICEPERSON.modalita_recesso')
    @inputType('text')
    @editable(true)
    @length(50)
    @order(66)
    modalita_recesso: string;

    @headerCode('GCE.GCEINVOICEPERSON.motivo_recesso')
    @inputType('text')
    @editable(true)
    @length(255)
    @order(67)
    motivo_recesso: string;

    @headerCode('GCE.GCEINVOICEPERSON.abilitato_estetica')
    @inputType('boolean')
    @editable(true)
    @order(68)
    abilitato_estetica: boolean;

    medicType?:GceMedicType;

    constructor();
    constructor(idfatturazione: number, descrizione: string, piva: string, fornitore_nav: string, medico_portale: string, piva_portale: string, cfisc_portale: string, regime_portale: string, capitale_portale: string, nome_nav: string, piva_nav: string, cfisc_nav: string, annullato: boolean, errore: boolean, desc_errore: string, email: string, codice_fiscale:string, data_nascita:Date | string, tipo_medico: number, indirizzo:string, citta:string, cap:string, provincia:string, capitale_sociale_invio_portale: number, regime_fiscale_invio_portale: string, dataora_invio_portale: Date | string, esito_invio_portale: string, messaggio_invio_portale: string, flg_invio_dati_portale: boolean);
    constructor(idfatturazione?: number, descrizione?: string, piva?: string, fornitore_nav?: string, medico_portale?: string, piva_portale?: string, cfisc_portale?: string, regime_portale?: string, capitale_portale?: string, nome_nav?: string, piva_nav?: string, cfisc_nav?: string, annullato?: boolean, errore?: boolean, desc_errore?: string, email?: string, codice_fiscale?:string, data_nascita?:Date | string, tipo_medico?: number, indirizzo?:string, citta?:string, cap?:string, provincia?:string, capitale_sociale_invio_portale?: number, regime_fiscale_invio_portale?: string, dataora_invio_portale?: Date | string, esito_invio_portale?: string, messaggio_invio_portale?: string, flg_invio_dati_portale?: boolean, id_profilo_xdent? : number, iscrizione_albo_medici? : string, iscrizione_albo_medici_prov?  : string, iscrizione_albo_odontoiatri?  : string, iscrizione_albo_odontoiatri_prov?  : string, data_laurea? : Date, scadenza_blsd? : Date | string, scadenza_radioprotezione?  : Date | string, scadenza_rc_professionale?  : Date | string, massimale_rc_professionale? : number, codice_iban? : string, indirizzo_pec? : string, cessato?: boolean, telefono?: string, flg_nofattura_portale?: boolean, url_image?:string, data_inizio_collaborazione?: Date | string, profilo_compenso?: number, profilo_compenso_desc?: string, sesso?: string, luogo_nascita?: string, ranking_operatore?: string, profilo_clinico?: string, aree_competenza_operatore?: string, laurea_luogo?: string, laurea_tipologia?: string, laurea_specializzazione?: string, numero_iscrizione_albo_igienisti?: string, data_iscrizione_albo?: Date | string, data_scadenza_assicurazione?: Date | string, nome_compagnia_assicurazione?: string, massimale_assicurazione?: number, data_fine_collaborazione_gruppo?: Date | string, modalita_collaborazione?: string, modalita_recesso?: string, motivo_recesso?: string, abilitato_estetica?: boolean
        ) {
        super();
        this.idfatturazione = idfatturazione || 0;
        this.descrizione = descrizione || '';
        this.piva = piva || '';
        this.fornitore_nav = fornitore_nav || '';
     //   this.codice_xdent = codice_xdent || null;
        this.annullato = annullato || false;
        this.cessato = cessato || false;
        this.desc_errore = desc_errore || '';
        this.medico_portale = medico_portale || '';
        this.piva_portale = piva_portale || '';
        this.cfisc_portale = cfisc_portale || '';
        this.regime_portale = regime_portale || '';
        this.capitale_portale = capitale_portale || '';
        this.nome_nav = nome_nav || '';
        this.piva_nav = piva_nav || '';
        this.cfisc_nav = cfisc_nav || '';
        this.errore = errore || false;
        this.email = email || '';
        this.codice_fiscale = codice_fiscale || '';
        this.data_nascita = data_nascita || new Date();
        this.tipo_medico = tipo_medico || 0;
        this.indirizzo = indirizzo || '';
        this.citta = citta || '';
        this.cap = cap || '';
        this.provincia = provincia || '';
        this.capitale_sociale_invio_portale = capitale_sociale_invio_portale || 0;
        this.regime_fiscale_invio_portale = regime_fiscale_invio_portale || '';
        this.dataora_invio_portale = dataora_invio_portale || new Date();
        this.esito_invio_portale = esito_invio_portale || '';
        this.messaggio_invio_portale = messaggio_invio_portale || '';
        this.flg_invio_dati_portale = flg_invio_dati_portale || false;
        this.id_profilo_xdent = id_profilo_xdent || 0;
        this.iscrizione_albo_medici = iscrizione_albo_medici || '';
        this.iscrizione_albo_medici_prov = iscrizione_albo_medici_prov || '';
        this.iscrizione_albo_odontoiatri = iscrizione_albo_odontoiatri || '';
        this.iscrizione_albo_odontoiatri_prov = iscrizione_albo_odontoiatri_prov || '';
        this.data_laurea = data_laurea || new Date();
        this.scadenza_blsd = scadenza_blsd || new Date();
        this.scadenza_radioprotezione = scadenza_radioprotezione || new Date();
        this.scadenza_rc_professionale =scadenza_rc_professionale || new Date();
        this.massimale_rc_professionale =massimale_rc_professionale || 0 ;
        this.codice_iban =codice_iban || '';
        this.indirizzo_pec =indirizzo_pec || '';
        this.telefono = telefono || '';
        this.flg_nofattura_portale = flg_nofattura_portale || false;
        this.url_image = url_image || '';
        this.data_inizio_collaborazione = data_inizio_collaborazione || null;
        this.profilo_compenso = profilo_compenso || null;
        this.profilo_compenso_desc = profilo_compenso_desc || '';
        this.sesso = sesso || '';
        this.luogo_nascita = luogo_nascita || '';
        this.ranking_operatore = ranking_operatore || '';
        this.profilo_clinico = profilo_clinico || '';
        this.aree_competenza_operatore = aree_competenza_operatore || '';
        this.laurea_luogo = laurea_luogo || '';
        this.laurea_tipologia = laurea_tipologia || '';
        this.laurea_specializzazione = laurea_specializzazione || '';
        this.numero_iscrizione_albo_igienisti = numero_iscrizione_albo_igienisti || '';
        this.data_iscrizione_albo = data_iscrizione_albo || null;
        this.data_scadenza_assicurazione = data_scadenza_assicurazione || null;
        this.nome_compagnia_assicurazione = nome_compagnia_assicurazione || '';
        this.massimale_assicurazione = massimale_assicurazione || null;
        this.data_fine_collaborazione_gruppo = data_fine_collaborazione_gruppo || null;
        this.modalita_collaborazione = modalita_collaborazione || '';
        this.modalita_recesso = modalita_recesso || '';
        this.motivo_recesso = motivo_recesso || '';
        this.abilitato_estetica = abilitato_estetica || false;
    }

    static getStructure(): Array<any> {
        let structure: any[] = Describer.getStructure(new GceInvoicePerson());
        structure.push(...this.getActions());
        return structure;
    }

    protected static getActions(): any[] {
        let actions: any[] = [];

        if(PermissionService.checkPermission("CGE_RCM") || PermissionService.checkPermission("CGE_ECM")){
            let actionCompensation = {
                action: undefined,
                callback: 'opendDialogCompensation',
                callbackOnForm: false,
                columnDef: 'actionCompensation',
                disabled: false,
                header: 'GCE.GCEINVOICEPERSON.COMPENSATION',
                dontShowHeader: false,
                length: 256,
                lookUp: {},
                primaryKey: false,
                reference: null,
                required: false,
                requiredOnNew: false,
                show: true,
                type: 'custom-action',
                values: null,
                visible: true,
                editable: false,
                visibleOnToggle: false,
                imageButton: 'assets/img/medic-compensation-white.png',
                imageTable: 'assets/img/medic-compensation.png',
                tooltip: 'GCE.GCEINVOICEPERSON.COMPENSATION.TOOLTIP',
                order: 3
            };
            actions.push(actionCompensation);
        }
        
        if(PermissionService.checkPermission("CGE_DMS")){
            let actionCompensationDMS = {
                action: undefined,
                callback: 'opendDialogCompensationDMS',
                callbackOnForm: false,
                columnDef: 'actionCompensationDMS',
                disabled: false,
                header: 'GCE.GCEINVOICEPERSON.COMPENSATIONDMS',
                dontShowHeader: false,
                length: 256,
                lookUp: {},
                primaryKey: false,
                reference: null,
                required: false,
                requiredOnNew: false,
                show: true,
                type: 'custom-action',
                values: null,
                visible: true,
                editable: false,
                visibleOnToggle: false,
                imageButton: 'assets/img/medic-compensation-white.png',
                imageTable: 'assets/img/medic-compensation.png',
                tooltip: 'GCE.GCEINVOICEPERSON.COMPENSATIONDMS.TOOLTIP',
                order: 4
            };
            actions.push(actionCompensationDMS);
        }

        if(PermissionService.checkPermission("CGE_RCD") || PermissionService.checkPermission("CGE_ECD")){
            let actionClinicAssociation = {
                action: undefined,
                callback: 'opendDialogClinicAssociation',
                callbackOnForm: false,
                columnDef: 'actionClinicAssociation',
                disabled: false,
                header: 'GCE.GCEINVOICEPERSON.CLINICASSOCIATION',
                dontShowHeader: false,
                length: 256,
                lookUp: {},
                primaryKey: false,
                reference: null,
                required: false,
                requiredOnNew: false,
                show: true,
                type: 'custom-action',
                values: null,
                visible: true,
                editable: false,
                visibleOnToggle: false,
                imageButton: 'assets/img/clinic-association-white.png',
                imageTable: 'assets/img/clinic-association.png',
                tooltip: 'GCE.GCEINVOICEPERSON.CLINICASSOCIATION.TOOLTIP',
                order: 5
            }
            actions.push(actionClinicAssociation);
        }

        if(PermissionService.checkPermission("CGE_CAN")){
            let actionCheckPerson = {
                action: undefined,
                callback: 'checkPerson',
                callbackOnForm: false,
                columnDef: 'actionCheckPerson',
                disabled: false,
                header: 'GCE.GCEINVOICEPERSON.CHECKPERSON',
                dontShowHeader: false,
                length: 256,
                lookUp: {},
                primaryKey: false,
                reference: null,
                required: false,
                requiredOnNew: false,
                show: true,
                type: 'custom-action',
                values: null,
                visible: true,
                editable: false,
                visibleOnToggle: false,
                imageButton: 'assets/img/check-person-white.png',
                imageTable: 'assets/img/check-person.png',
                tooltip: 'GCE.GCEINVOICEPERSON.CHECKPERSON.TOOLTIP',
                order: 5
            }
            actions.push(actionCheckPerson);
        }

        
        return actions;
    }
}
